import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { SPECIALITIES_ROUTE } from '../constants/routes';
import { TELECARE_PHONE, TELECARE_PHONE_HREF } from '../constants/contact';

// Unknown addresses inside the booking site, styled like the booking steps.
const NotFound: FC = () => (
  <section className="panel">
    <h2>We can&apos;t find that page</h2>
    <p className="psub">
      {'The link may be out of date. You can start a new booking, or call Telecare on '}
      <a href={TELECARE_PHONE_HREF}>{TELECARE_PHONE}</a>
      .
    </p>
    <Link className="btn btn-p" to={SPECIALITIES_ROUTE}>Start a booking</Link>
  </section>
);

export default NotFound;
